import clsx from "clsx"

export const labelStyles = error =>
  clsx(
    "block body font-bold pb-2",
    !error && "text-mineralGray",
    error && "text-red"
  )

export const errorStyles = "pt-1 text-red small-copy"
